import { render, staticRenderFns } from "./MdrlEdit.vue?vue&type=template&id=e60e6bae&scoped=true&"
import script from "./MdrlEdit.vue?vue&type=script&lang=js&"
export * from "./MdrlEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e60e6bae",
  null
  
)

export default component.exports